import React from 'react';
import { Box, Grid } from '@mui/material';
import LeadsCountWidget from '../components/Reports/LeadsCountWidget';
import TaskStatusSummaryWidget from '../components/Reports/TaskStatusSummaryWidget';
import TaskGrowthWidget from '../components/Reports/TaskGrowthWidget';

const ReportsPage: React.FC = () => {


  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {/* Left column - Two stacked square widgets */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
              <LeadsCountWidget />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TaskGrowthWidget />
            </Grid>
          </Grid>
        </Grid>
        
        {/* Right column - One rectangular widget with double height */}
        <Grid size={{ xs: 12, md: 6 }}>
          <TaskStatusSummaryWidget />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReportsPage;